import { render, staticRenderFns } from "./AdminResourceUsageNew.vue?vue&type=template&id=69a5c662"
import script from "./AdminResourceUsageNew.vue?vue&type=script&lang=js"
export * from "./AdminResourceUsageNew.vue?vue&type=script&lang=js"
import style0 from "./AdminResourceUsageNew.vue?vue&type=style&index=0&id=69a5c662&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports